export var NAVIGATION_MENU_CONFIGS = [

    {
        type: "icontext",
        label: "Gestionale",
        href: "../gespe/fontiFinanziamento",
        icon: "mdi-home",
		  codePermission: "access_gespe_page"
    },

];

export var NAVIGATION_SUB_MENU_CONFIGS = {
    type: "icontext",
    label: "Menu Sigma",
    icon: "mdi-menu",
    children: [
        {
            type: "icontext",
            label: "Home",
            href: "../main",
            icon: "mdi-home"
        },
        {
            type: "icontext",
            label: "Amministrazione",
            href: "../userconfigurations/adminUsers",
            codePermission: "access_admin_page",
            icon: "mdi-cog"
        },
        {
            type: "icontext",
            label: "Procedimenti",
            href: "../pratiche/gestionePratiche",
            codePermission: "CAN_MANAGE_PRATICHE",
            icon: "mdi-tools"
        },
        {
            type: "icontext",
            label: "I tuoi Procedimenti",
            href: "../pratiche/praticheUtente",
            codePermission: "CAN_USER_HANDLE_PRATICHE",
            icon: "mdi-cog"
        },
        {
            type: "icontext",
            label: "Gestione Dati",
            href: "../datamanager/adminDataRegistry",
            codePermission: "access_admin_page",
            icon: "mdi-cog"
        },
        {
            type: "icontext",
            label: "Ricerca",
            href: "../search/searchPage",
            icon: "mdi-magnify"
        }
    ]
};

export var NAVIGATION_MENU_AUTH_CONFIGS = {
    logout: {
        type: "icon",
        label: "Esci",
        href: "../logout",
        icon: "mdi-logout"
    },

    login: {
        type: "icontext",
        label: "Login",
        href: "../authentication/login",
        icon: "mdi-lock"
    }
}
